import Vue from 'vue'
import VueRouter from 'vue-router'
import {Message} from 'element-ui'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {path: '/', name: 'login', component: () => import('../views/login/index.vue')},
    {path: '/follow', name: 'follow', component: () => import('../views/follow/index.vue')},
    {
        path: '/layout', name: 'layout', component: () => import('../views/layout/index.vue'),
        redirect: '/home',
        children: [
            {path: '/home', name: 'home', component: () => import('../views/home/index.vue')},
            {path: '/permission', name: 'permission', component: () => import('../views/permission/index.vue')},
            {path: '/data', name: 'data', component: () => import('../views/trend/index.vue')},
            {path: '/feed', name: 'feed', component: () => import('../views/feedback/index.vue')},
            {path: '/user', name: 'user', component: () => import('../views/user/index.vue')},
            {path: '/mass', name: 'mass', component: () => import('../views/quality/index.vue')},
            {path: '/audit', name: 'audit', component: () => import('../views/audit/index.vue')},
            {path: '/image', name: 'image', component: () => import('../views/image/index.vue')},
            {path: '/input', name: 'input', component: () => import('../views/tutorial/index.vue')},
            {path: '/center', name: 'center', component: () => import('../views/institution/index.vue')},
            {path: '/config', name: 'config', component: () => import('../views/config/index.vue')},
            {path: '/patient', name: 'patient', component: () => import('../views/patient/index.vue')},
            {path: '/image_detail', name: 'image_detail', component: () => import('../views/image/components/ImageDetail.vue')},
            {path: '/audit_basic', name: 'audit_basic', component: () => import('../views/audit/components/AuditBasic.vue')},
            {path: '/audit_clinic', name: 'audit_clinic', component: () => import('../views/audit/components/AuditClinic.vue')},
            {path: '/audit_follow', name: 'audit_follow', component: () => import('../views/audit/components/AuditFollow.vue')},
        ]
    },
    {path: '*', name: '404', component: () => import('../components/NotFound.vue')},
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const token = store.state.auth.token
    if (token) {
        if (to.path === '/') {
            next('/home')
        } else {
            next()
        }
    } else {
        if (to.path === '/') {
            next()
        } else {
            Message.warning('请先登录后再访问该页面')
            next('/')
        }
    }
})

export default router
